import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import sessionEngagementActivityAnalyticService from '../../../services/session-engagement-activity-analytics.service';

const SessionMetrics = () => {
  const [sessionDetails, setSessionDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUserMetrics = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await sessionEngagementActivityAnalyticService.getTotalSessionDetails();
        setSessionDetails(data?.total_sessions || {});
      } catch (err) {
        console.error('Error fetching user metrics:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getUserMetrics();
  }, []);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load user registration metrics details.
      </div>
    );
  }

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['Daily', 'Weekly', 'Monthly'],
    },
    yaxis: {
      title: { text: 'Sessions' },
    },
    fill: { opacity: 1 },
    tooltip: {
      y: {
        formatter: (val) => `${val} sessions`,
      },
    },
    colors: ['#4F46E5', '#16A34A'],
  };

  const series = [
    {
      name: 'Total Sessions',
      data: [
        sessionDetails?.daily,
        sessionDetails?.weekly,
        sessionDetails?.monthly,
      ],
    },
  ];

  return (
    <div className="mt-3">
      <Chart options={chartOptions} series={series} type="bar" height={300} />
    </div>
  );
};

export default SessionMetrics;
